export var LISTS_DEFAULT_PAGE_AMOUNT = 100;
export var HOME_PAGE_URL = '/lists';
export var CREATE_LIST_URL = "".concat(HOME_PAGE_URL, "/new");
